export default __webpack_public_path__ + "static/media/avatar-two-tones.53c46a36.svg";